// format array by separator(eg. [1,2,3] => '1|2|3')
const formatBySeparator = (array, key, separator) => {
    return array?.length > 0 && array.map((item) => item[key]).join(separator);
};

export { formatBySeparator };
